import { createContext, useContext, useState } from "react";

export const translations = {
  it: {
    nav: {
      manifesto: "Manifesto",
      pillars: "Territori",
      events: "Eventi",
      media: "Media",
      community: "Community",
      login: "Accedi",
      logout: "Esci",
    },
    hero: {
      eyebrow: "4X4 — ADVENTURE — COMMUNITY",
      activeBadge: "SPEDIZIONE ATTIVA",
      activeEvent: "APPENNINO MUD FEST / 08.08.26",
      lines: ["STRADE VERE.", "MOTORI ACCESI.", "PERSONE GIUSTE."],
      sub: "Uscite, raduni, tour offroad e weekend overland. Dust Republic trasforma la passione per il fuoristrada in esperienze da vivere e condividere — con la cura di un vero organizzatore di avventure.",
      ctaJoin: "Unisciti alla Republic",
      ctaEvents: "Esplora il calendario",
      scroll: "SCORRI PER PARTIRE",
    },
    ribbon: [
      "STRADE VERE — MOTORI ACCESI — PERSONE GIUSTE",
      "43.06°N 11.61°E — VAL D'ORCIA",
      "NON È SOLO OFFROAD",
      "31.15°N 3.98°W — ERG CHEBBI",
      "È APPARTENERE ALLA REPUBLIC",
      "44.19°N 10.94°E — APPENNINO",
    ],
    manifesto: {
      eyebrow: "IL MANIFESTO",
      title: "Non un club. Una Republic.",
      intro: "Non siamo il solito gruppo di appassionati. Siamo un brand di esperienze offroad: itinerari studiati, organizzazione, sicurezza, contenuti e atmosfera.",
      chapters: [
        {
          num: "01",
          title: "Strade vere",
          text: "Niente asfalto, niente scorciatoie. Cerchiamo strade bianche, guadi, creste e piste dimenticate. Il territorio si vive, non si attraversa.",
        },
        {
          num: "02",
          title: "Motori accesi",
          text: "Il rombo all'alba, la sabbia che morde le gomme, il verricello pronto. Ogni uscita è preparata: percorso studiato, sicurezza, ritmo giusto.",
        },
        {
          num: "03",
          title: "Persone giuste",
          text: "Il mezzo è solo il punto di partenza. Contano le persone accanto a te al falò, quelle che ti tirano fuori dal fango e brindano al tramonto.",
        },
      ],
    },
    pillars: {
      eyebrow: "I TERRITORI",
      title: "Cinque modi di vivere la polvere",
      cta: "Scopri di più",
      items: [
        {
          key: "offroad",
          title: "Offroad",
          tag: "TRAIL / 4X4",
          text: "Percorsi sterrati, montagne e strade bianche. Itinerari pensati per vivere il territorio con il tuo 4x4.",
        },
        {
          key: "adventure",
          title: "Adventure",
          tag: "OVERLAND / CAMP",
          text: "Weekend, campeggio e overland. Tutto ciò che porta l'esperienza oltre il semplice giro in macchina.",
        },
        {
          key: "community",
          title: "Community",
          tag: "CREW / PEOPLE",
          text: "Persone accomunate dalla stessa passione. Il mezzo diventa il punto di partenza per nuove esperienze e conoscenze.",
        },
        {
          key: "media",
          title: "Media & Content",
          tag: "PHOTO / FILM",
          text: "Foto, video e contenuti degli eventi. Raccontiamo non solo i mezzi, ma le persone e le esperienze vissute.",
        },
        {
          key: "events",
          title: "Eventi",
          tag: "CALENDAR / TOUR",
          text: "Un calendario di esperienze organizzate: itinerari, tappe, attività e momenti dedicati alla community.",
        },
      ],
    },
    admin: {
      title: "Quartier Generale",
      back: "Torna al sito",
      tabEvents: "Eventi",
      tabJoins: "Adesioni",
      newEvent: "Nuovo evento",
      edit: "Modifica",
      del: "Elimina",
      save: "Salva evento",
      cancel: "Annulla",
      confirmDelete: "Eliminare definitivamente questo evento?",
      denied: "Area riservata al Quartier Generale.",
      deniedSub: "Accedi con un account admin per gestire eventi e adesioni.",
      loginAdmin: "Accedi come admin",
      saved: "Evento salvato",
      deleted: "Evento eliminato",
      error: "Operazione non riuscita",
      noJoins: "Nessuna richiesta di adesione per ora.",
      spotsLabel: "posti",
      tabBookings: "Prenotazioni",
      noBookings: "Nessuna prenotazione per ora.",
      bookedOn: "prenotato il",
      exportCsv: "Scarica CSV",
      tabWaitlist: "Liste d'attesa",
      noWaitlist: "Nessuna lista d'attesa attiva.",
      waitingSince: "in attesa dal",
      remind: "Promemoria",
      remindConfirm: "Inviare l'email di promemoria a tutti i partecipanti?",
      remindSent: "Promemoria inviato",
      tabStats: "Numeri",
      statMembers: "Membri registrati",
      statRequests: "Richieste di adesione",
      statBookings: "Prenotazioni",
      statCheckins: "Check-in",
      statWaiting: "In lista d'attesa",
      statSpots: "Posti venduti",
      topEvents: "Eventi più richiesti",
      reqTitle: "Requisiti minimi mezzo",
      reqTires: "Gomme minime",
      reqWinch: "Verricello richiesto",
      reqLift: "Assetto minimo",
      rigMismatch: "assetto non conforme",
      checkedIn: "presente",
      tabMedia: "Media IG",
      pinLabel: "URL post Instagram (…/p/… oppure …/reel/…)",
      addPin: "Fissa post",
      pinAdded: "Post fissato nella vetrina Media",
      pinDeleted: "Post rimosso",
      invalidUrl: "URL Instagram non valido",
      noPins: "Nessun post fissato. Incolla gli URL dei post migliori di @dust_republic.",
      fields: {
        titleIt: "Titolo (IT)",
        titleEn: "Titolo (EN)",
        descIt: "Descrizione (IT)",
        descEn: "Descrizione (EN)",
        itinIt: "Itinerario (IT) — una riga per tappa",
        itinEn: "Itinerario (EN) — una riga per tappa",
        date: "Data",
        days: "Giorni",
        difficulty: "Difficoltà",
        location: "Località",
        coords: "Coordinate",
        price: "Prezzo €",
        spots: "Posti totali",
        image: "URL immagine",
      },
    },
    member: {
      title: "La tua area membri",
      role: "Ruolo",
      myEvents: "Le tue spedizioni",
      noEvents: "Non hai ancora prenotato nessun evento.",
      explore: "Esplora il calendario",
      bookedOn: "Prenotato il",
      cancel: "Annulla prenotazione",
      cancelConfirm: "Annullare la prenotazione? Il posto tornerà disponibile.",
      cancelled: "Prenotazione annullata. Posto liberato.",
      rigTitle: "Assetto del mezzo",
      tires: "Gomme",
      lift: "Assetto",
      winch: "Verricello",
      saveRig: "Salva assetto",
      rigSaved: "Assetto salvato",
      tiresOpts: { street: "Stradali", at: "All-Terrain", mt: "Mud-Terrain" },
      liftOpts: { stock: "Originale", lift2: "Rialzato +5 cm", lift4: "Rialzato +10 cm" },
      checkin: "Check-in — sono presente",
      checkedIn: "Presenza confermata",
      rigWarn: "Il tuo assetto non raggiunge i requisiti minimi di questo evento",
      badgeTitle: "Badge check-in",
      badgeSub: "Mostralo al Quartier Generale il giorno dell'evento.",
      reviewCta: "Lascia una recensione",
      reviewTitle: "Com'è andata?",
      commentPh: "Racconta la spedizione in due righe…",
      sendReview: "Pubblica recensione",
      reviewSent: "Grazie! Recensione pubblicata.",
      reviewed: "Recensione inviata",
      certificate: "Scarica certificato",
      certTitle: "SPEDIZIONE COMPLETATA",
      certDone: "COMPLETATA IL",
      back: "Torna al sito",
      denied: "Accedi per vedere la tua area membri.",
      loginCta: "Accedi",
    },
    detail: {
      back: "Tutti gli eventi",
      program: "Il programma",
      gallery: "Galleria della spedizione",
      map: "Dove si va",
      availability: "Disponibilità",
      notFound: "Evento non trovato.",
      share: "Condividi la spedizione",
      copied: "Link copiato",
      weather: "Meteo previsto",
      weatherNote: "Le previsioni saranno disponibili a ridosso dell'evento.",
      precip: "Prob. pioggia",
      wxClear: "Sereno",
      wxCloudy: "Nuvoloso",
      wxFog: "Nebbia",
      wxRain: "Pioggia",
      wxSnow: "Neve",
      wxStorm: "Temporale",
      requirements: "Requisiti minimi",
      reviews: "Recensioni della crew",
      noReviews: "Nessuna recensione ancora. La prima dopo la prossima spedizione.",
    },
    scan: {
      title: "Check-in spedizione",
      adminOnly: "Solo il Quartier Generale può confermare le presenze.",
      loginAdmin: "Accedi come admin",
      invalid: "Badge non valido.",
      bookings: "Prenotazioni del membro",
      confirm: "Conferma presenza",
      confirmed: "Presente",
      done: "Presenza registrata",
      noBookings: "Nessuna prenotazione per questo membro.",
      back: "Torna al sito",
    },
    banner: {
      eyebrow: "OFF-ROAD LIFESTYLE",
      titleA: "Non è solo offroad.",
      titleB: "È appartenere alla Republic.",
      text: "Sali a bordo e scopri un mondo di piste, panorami e libertà. Condividiamo la passione per l'off-road, il campeggio e la natura incontaminata — insieme a chi la vive come te.",
      cta: "Unisciti alla Republic",
    },
    events: {
      eyebrow: "EVENTI / 2026",
      title: "Il calendario delle spedizioni",
      filterAll: "Tutti",
      difficulties: { soft: "Soft Rover", trail: "Trail Raider", extreme: "Extreme Overland" },
      days: "giorni",
      day: "giorno",
      spotsLeft: "posti liberi",
      soldOut: "Sold out",
      joinWaitlist: "Entra in lista d'attesa",
      inWaitlist: "In lista d'attesa",
      waitlistSuccess: "Sei in lista d'attesa. Ti avvisiamo se si libera un posto.",
      book: "Prenota il tuo posto",
      booked: "Prenotato",
      itinerary: "Itinerario",
      close: "Chiudi",
      from: "a partire da",
      loginToBook: "Accedi o registrati per prenotare il tuo posto",
      bookSuccess: "Posto prenotato. Ci vediamo sulla pista.",
      loadError: "Impossibile caricare gli eventi",
      empty: "Nessun evento per questo filtro",
    },
    media: {
      eyebrow: "MEDIA & CONTENT",
      title: "Polvere, non filtri.",
      sub: "Foto e video dalle spedizioni: raccontiamo le persone, non solo i mezzi.",
      badge: "REC",
      latest: "Diretta da Instagram",
      follow: "Segui @dust_republic",
    },
    join: {
      eyebrow: "COMMUNITY",
      title: "Entra nella Republic.",
      sub: "Compila la richiesta di adesione: raccontaci chi sei e cosa guidi. Il quartier generale ti risponderà con i prossimi passi.",
      name: "Nome e cognome",
      namePh: "Marco Rossi",
      email: "Email",
      emailPh: "marco@esempio.it",
      vehicle: "Il tuo mezzo",
      vehiclePh: "Jeep Wrangler JL 2.0",
      experience: "Esperienza offroad",
      expOptions: { rookie: "Prime uscite", intermediate: "Trail regular", veteran: "Veterano del fango" },
      message: "Raccontaci qualcosa di te (facoltativo)",
      messagePh: "Cosa cerchi nella Republic?",
      submit: "Invia richiesta di adesione",
      sending: "Invio in corso…",
      successTitle: "Richiesta inviata.",
      successText: "Benvenuto ai cancelli della Republic. Ti ricontatteremo presto via email.",
      error: "Qualcosa è andato storto. Riprova.",
      hqTitle: "QUARTIER GENERALE",
      hqPlace: "Como, IT",
      hqMail: "infodustrepublic@gmail.com",
      hqWhatsApp: "+39 378 061 8293",
    },
    auth: {
      loginTitle: "Accesso membri",
      registerTitle: "Diventa membro",
      email: "Email",
      password: "Password",
      name: "Nome e cognome",
      vehicle: "Il tuo mezzo (facoltativo)",
      loginCta: "Accedi",
      registerCta: "Crea account",
      switchToRegister: "Non sei dei nostri? Registrati",
      switchToLogin: "Hai già un account? Accedi",
      welcome: "Bentornato nella Republic",
      registered: "Benvenuto nella Republic",
      loggedOut: "Sei uscito. Motori spenti… per ora.",
      genericError: "Qualcosa è andato storto. Riprova.",
      forgotLink: "Password dimenticata?",
      forgotTitle: "Recupera password",
      forgotSub: "Inserisci la tua email: ti mandiamo un link per reimpostare la password.",
      forgotCta: "Invia link di reset",
      forgotSuccess: "Se l'email è registrata, riceverai il link a breve.",
      resetTitle: "Nuova password",
      resetSub: "Scegli una nuova password per il tuo account.",
      confirmPassword: "Conferma password",
      resetCta: "Salva nuova password",
      resetSuccess: "Password aggiornata. Ora puoi accedere.",
      passwordMismatch: "Le password non coincidono.",
      resetInvalid: "Link non valido o scaduto. Richiedine uno nuovo.",
    },
    footer: {
      payoffA: "NON È SOLO OFFROAD.",
      payoffB: "È APPARTENERE ALLA REPUBLIC.",
      tagline: "4X4 — ADVENTURE — COMMUNITY",
      rights: "DUST REPUBLIC — Tutti i diritti riservati",
      built: "Strade vere. Motori accesi. Persone giuste.",
      follow: "Seguici",
    },
  },
  en: {
    nav: {
      manifesto: "Manifesto",
      pillars: "Territories",
      events: "Events",
      media: "Media",
      community: "Community",
      login: "Sign in",
      logout: "Sign out",
    },
    hero: {
      eyebrow: "4X4 — ADVENTURE — COMMUNITY",
      activeBadge: "ACTIVE EXPEDITION",
      activeEvent: "APPENNINO MUD FEST / 08.08.26",
      lines: ["REAL TRAILS.", "ENGINES RUNNING.", "THE RIGHT CROWD."],
      sub: "Runs, gatherings, offroad tours and overland weekends. Dust Republic turns a passion for 4x4 into experiences to live and share — run with the care of a true adventure organiser.",
      ctaJoin: "Join the Republic",
      ctaEvents: "Explore the calendar",
      scroll: "SCROLL TO ROLL OUT",
    },
    ribbon: [
      "REAL TRAILS — ENGINES RUNNING — THE RIGHT CROWD",
      "43.06°N 11.61°E — VAL D'ORCIA",
      "IT'S NOT JUST OFFROAD",
      "31.15°N 3.98°W — ERG CHEBBI",
      "IT'S BELONGING TO THE REPUBLIC",
      "44.19°N 10.94°E — APENNINES",
    ],
    manifesto: {
      eyebrow: "THE MANIFESTO",
      title: "Not a club. A Republic.",
      intro: "We are not your average enthusiast group. We are an offroad experience brand: studied itineraries, organisation, safety, content and atmosphere.",
      chapters: [
        {
          num: "01",
          title: "Real trails",
          text: "No tarmac, no shortcuts. We hunt for white roads, fords, ridgelines and forgotten tracks. Territory is to be lived, not crossed.",
        },
        {
          num: "02",
          title: "Engines running",
          text: "The rumble at dawn, sand biting the tyres, the winch ready. Every run is prepared: planned route, safety, the right pace.",
        },
        {
          num: "03",
          title: "The right crowd",
          text: "The rig is just the starting point. What matters is the people next to you at the fire — the ones who pull you out of the mud and toast the sunset.",
        },
      ],
    },
    pillars: {
      eyebrow: "THE TERRITORIES",
      title: "Five ways to live the dust",
      cta: "Discover more",
      items: [
        {
          key: "offroad",
          title: "Offroad",
          tag: "TRAIL / 4X4",
          text: "Dirt tracks, mountains and white roads. Itineraries designed to live the territory in your 4x4.",
        },
        {
          key: "adventure",
          title: "Adventure",
          tag: "OVERLAND / CAMP",
          text: "Weekends, camping and overlanding. Everything that takes the experience beyond a simple drive.",
        },
        {
          key: "community",
          title: "Community",
          tag: "CREW / PEOPLE",
          text: "People bound by the same passion. The vehicle becomes the starting point for new experiences and friendships.",
        },
        {
          key: "media",
          title: "Media & Content",
          tag: "PHOTO / FILM",
          text: "Photos, videos and event content. We tell the story of people and lived experiences, not just machines.",
        },
        {
          key: "events",
          title: "Events",
          tag: "CALENDAR / TOUR",
          text: "A calendar of organised experiences: itineraries, stages, activities and moments dedicated to the community.",
        },
      ],
    },
    admin: {
      title: "Headquarters",
      back: "Back to the site",
      tabEvents: "Events",
      tabJoins: "Membership requests",
      newEvent: "New event",
      edit: "Edit",
      del: "Delete",
      save: "Save event",
      cancel: "Cancel",
      confirmDelete: "Permanently delete this event?",
      denied: "Restricted to Headquarters.",
      deniedSub: "Sign in with an admin account to manage events and requests.",
      loginAdmin: "Sign in as admin",
      saved: "Event saved",
      deleted: "Event deleted",
      error: "Operation failed",
      noJoins: "No membership requests yet.",
      spotsLabel: "spots",
      tabBookings: "Bookings",
      noBookings: "No bookings yet.",
      bookedOn: "booked on",
      exportCsv: "Download CSV",
      tabWaitlist: "Waitlists",
      noWaitlist: "No active waitlists.",
      waitingSince: "waiting since",
      remind: "Reminder",
      remindConfirm: "Send the reminder email to all participants?",
      remindSent: "Reminder sent",
      tabStats: "Numbers",
      statMembers: "Registered members",
      statRequests: "Membership requests",
      statBookings: "Bookings",
      statCheckins: "Check-ins",
      statWaiting: "On waitlists",
      statSpots: "Spots sold",
      topEvents: "Most requested events",
      reqTitle: "Minimum rig requirements",
      reqTires: "Minimum tyres",
      reqWinch: "Winch required",
      reqLift: "Minimum suspension",
      rigMismatch: "rig below requirements",
      checkedIn: "checked in",
      tabMedia: "IG Media",
      pinLabel: "Instagram post URL (…/p/… or …/reel/…)",
      addPin: "Pin post",
      pinAdded: "Post pinned to the Media showcase",
      pinDeleted: "Post removed",
      invalidUrl: "Invalid Instagram URL",
      noPins: "No pinned posts. Paste the URLs of @dust_republic's best posts.",
      fields: {
        titleIt: "Title (IT)",
        titleEn: "Title (EN)",
        descIt: "Description (IT)",
        descEn: "Description (EN)",
        itinIt: "Itinerary (IT) — one line per stage",
        itinEn: "Itinerary (EN) — one line per stage",
        date: "Date",
        days: "Days",
        difficulty: "Difficulty",
        location: "Location",
        coords: "Coordinates",
        price: "Price €",
        spots: "Total spots",
        image: "Image URL",
      },
    },
    member: {
      title: "Your member area",
      role: "Role",
      myEvents: "Your expeditions",
      noEvents: "You haven't booked any events yet.",
      explore: "Explore the calendar",
      bookedOn: "Booked on",
      cancel: "Cancel booking",
      cancelConfirm: "Cancel this booking? The spot will become available again.",
      cancelled: "Booking cancelled. Spot freed.",
      rigTitle: "Rig setup",
      tires: "Tyres",
      lift: "Suspension",
      winch: "Winch",
      saveRig: "Save setup",
      rigSaved: "Setup saved",
      tiresOpts: { street: "Road", at: "All-Terrain", mt: "Mud-Terrain" },
      liftOpts: { stock: "Stock", lift2: "Lifted +2 in", lift4: "Lifted +4 in" },
      checkin: "Check in — I'm here",
      checkedIn: "Attendance confirmed",
      rigWarn: "Your rig doesn't meet this event's minimum requirements",
      badgeTitle: "Check-in badge",
      badgeSub: "Show it to the Headquarters crew on event day.",
      reviewCta: "Leave a review",
      reviewTitle: "How was it?",
      commentPh: "Tell us about the expedition in a couple of lines…",
      sendReview: "Publish review",
      reviewSent: "Thanks! Review published.",
      reviewed: "Review sent",
      certificate: "Download certificate",
      certTitle: "EXPEDITION COMPLETED",
      certDone: "COMPLETED ON",
      back: "Back to the site",
      denied: "Sign in to see your member area.",
      loginCta: "Sign in",
    },
    detail: {
      back: "All events",
      program: "The program",
      gallery: "Expedition gallery",
      map: "Where we're headed",
      availability: "Availability",
      notFound: "Event not found.",
      share: "Share the expedition",
      copied: "Link copied",
      weather: "Expected weather",
      weatherNote: "Forecast will be available closer to the event.",
      precip: "Rain chance",
      wxClear: "Clear",
      wxCloudy: "Cloudy",
      wxFog: "Fog",
      wxRain: "Rain",
      wxSnow: "Snow",
      wxStorm: "Storm",
      requirements: "Minimum requirements",
      reviews: "Crew reviews",
      noReviews: "No reviews yet. The first one after the next expedition.",
    },
    scan: {
      title: "Expedition check-in",
      adminOnly: "Only Headquarters can confirm attendance.",
      loginAdmin: "Sign in as admin",
      invalid: "Invalid badge.",
      bookings: "Member bookings",
      confirm: "Confirm attendance",
      confirmed: "Present",
      done: "Attendance recorded",
      noBookings: "No bookings for this member.",
      back: "Back to the site",
    },
    banner: {
      eyebrow: "OFF-ROAD LIFESTYLE",
      titleA: "It's not just offroad.",
      titleB: "It's belonging to the Republic.",
      text: "Hop in and discover a world of trails, views and freedom. We share the passion for off-road, camping and untouched nature — with people who live it like you.",
      cta: "Join the Republic",
    },
    events: {
      eyebrow: "EVENTS / 2026",
      title: "The expedition calendar",
      filterAll: "All",
      difficulties: { soft: "Soft Rover", trail: "Trail Raider", extreme: "Extreme Overland" },
      days: "days",
      day: "day",
      spotsLeft: "spots left",
      soldOut: "Sold out",
      joinWaitlist: "Join the waitlist",
      inWaitlist: "On the waitlist",
      waitlistSuccess: "You're on the waitlist. We'll let you know if a spot frees up.",
      book: "Book your spot",
      booked: "Booked",
      itinerary: "Itinerary",
      close: "Close",
      from: "from",
      loginToBook: "Sign in or register to book your spot",
      bookSuccess: "Spot booked. See you on the trail.",
      loadError: "Could not load events",
      empty: "No events for this filter",
    },
    media: {
      eyebrow: "MEDIA & CONTENT",
      title: "Dust, not filters.",
      sub: "Photos and films from the expeditions: we tell the story of people, not just machines.",
      badge: "REC",
      latest: "Live from Instagram",
      follow: "Follow @dust_republic",
    },
    join: {
      eyebrow: "COMMUNITY",
      title: "Join the Republic.",
      sub: "Fill in the membership request: tell us who you are and what you drive. HQ will get back to you with the next steps.",
      name: "Full name",
      namePh: "John Doe",
      email: "Email",
      emailPh: "john@example.com",
      vehicle: "Your rig",
      vehiclePh: "Jeep Wrangler JL 2.0",
      experience: "Offroad experience",
      expOptions: { rookie: "First runs", intermediate: "Trail regular", veteran: "Mud veteran" },
      message: "Tell us something about you (optional)",
      messagePh: "What are you looking for in the Republic?",
      submit: "Send membership request",
      sending: "Sending…",
      successTitle: "Request sent.",
      successText: "Welcome to the gates of the Republic. We'll get back to you by email soon.",
      error: "Something went wrong. Try again.",
      hqTitle: "HEADQUARTERS",
      hqPlace: "Como, IT",
      hqMail: "infodustrepublic@gmail.com",
      hqWhatsApp: "+39 378 061 8293",
    },
    auth: {
      loginTitle: "Member sign in",
      registerTitle: "Become a member",
      email: "Email",
      password: "Password",
      name: "Full name",
      vehicle: "Your rig (optional)",
      loginCta: "Sign in",
      registerCta: "Create account",
      switchToRegister: "Not one of us yet? Register",
      switchToLogin: "Already have an account? Sign in",
      welcome: "Welcome back to the Republic",
      registered: "Welcome to the Republic",
      loggedOut: "Signed out. Engines off… for now.",
      genericError: "Something went wrong. Try again.",
      forgotLink: "Forgot password?",
      forgotTitle: "Recover password",
      forgotSub: "Enter your email: we'll send you a link to reset your password.",
      forgotCta: "Send reset link",
      forgotSuccess: "If the email is registered, you'll receive the link shortly.",
      resetTitle: "New password",
      resetSub: "Choose a new password for your account.",
      confirmPassword: "Confirm password",
      resetCta: "Save new password",
      resetSuccess: "Password updated. You can now sign in.",
      passwordMismatch: "Passwords don't match.",
      resetInvalid: "Invalid or expired link. Request a new one.",
    },
    footer: {
      payoffA: "IT'S NOT JUST OFFROAD.",
      payoffB: "IT'S BELONGING TO THE REPUBLIC.",
      tagline: "4X4 — ADVENTURE — COMMUNITY",
      rights: "DUST REPUBLIC — All rights reserved",
      built: "Real trails. Engines running. The right crowd.",
      follow: "Follow us",
    },
  },
};

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState("it");
  const t = translations[lang];
  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  return useContext(LanguageContext);
}
